import { render, staticRenderFns } from "./speed.vue?vue&type=template&id=b9b9a9d4&scoped=true"
import script from "./speed.vue?vue&type=script&lang=js"
export * from "./speed.vue?vue&type=script&lang=js"
import style0 from "./speed.vue?vue&type=style&index=0&id=b9b9a9d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b9a9d4",
  null
  
)

export default component.exports